<template>
  <v-dialog v-model="mostrado" max-width="100%">
    <v-card>
      <v-card-title class="pt-2 pb-0">DESEMBOLSO DE RECURSOS</v-card-title>

      <v-divider class="my-2"></v-divider>

      <v-card-text class="pb-0">
        <v-row dense>
          <v-col cols="12" md="6">
            <span class="h5 d-block"> <strong>Solicitud N°: </strong>{{ item.numero }} </span>
            <span class="h5 d-block"> <strong>Solicitante: </strong>{{ item.user }} </span>
            <span class="h5 d-block"> <strong>Fecha Solicitud: </strong>{{ item.created_at }} </span>
          </v-col>

          <v-col cols="12" md="6">
            <span class="h5 d-block"> <strong>Estado Solicitud: </strong>{{ item.estado }} </span>
            <span class="h5 d-block">
              <strong>Tipo Solicitud: </strong>{{ item.tipo == tipoSolicitudRecursos ? 'Sedes' : 'Nacional' }}
            </span>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <span class="h5 mb-0 d-block"> <strong>Detalle Solicitud: </strong></span>

            <TablaDetalleDesembolso
              :detallesSolicitud="detallesSolicitud"
              :tipo="tipo"
              :modalMostrado="mostrado"
              @actualizarDetallesSolicitudesSeleccionadas="
                detallesSolicitudesSeleccionados = $event
              "></TablaDetalleDesembolso>
          </v-col>
        </v-row>

        <v-form>
          <v-row dense>
            <v-col cols="12" lg="3" offset-lg="3">
              <label for="">Fecha desembolso <span class="text-danger">(*)</span></label>
              <input type="datetime-local" v-model="form.fecha_desembolso" class="form-control" required />
              <small v-for="error in errores.fecha_desembolso" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" lg="6" offset-lg="3">
              <v-textarea
                outlined
                name="Observacion"
                label="Observacion"
                hide-details
                v-model="form.observaciones"></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrarModal"> Cerrar </v-btn>
        <v-btn color="blue darken-1" text @click.prevent="aceptarDesembolso"> Guardar </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="3000">
      Complete los campos
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>

    <ConfirmacionAccion
      ref="confirmacion"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="validar" />
  </v-dialog>
</template>
  
<script>
import SolicitudServices from '../services/solicitud';
import { TIPOS_SOLICITUD, ESTADOS_DETALLE_SOLICITUD } from '../utils';
import TablaDetalleDesembolso from './TablaDetalleDesembolso.vue';
import ConfirmacionAccion from '@/components/ConfirmacionAccion.vue';

export default {
  name: 'ModalDesembolsar',
  components: {
    TablaDetalleDesembolso,
    ConfirmacionAccion,
  },
  props: {
    tipo: {
      type: String,
      validator: (value) => {
        return [TIPOS_SOLICITUD.RECURSOS, TIPOS_SOLICITUD.GASTOS, 'todos'].includes(value);
      },
    },
  },
  data() {
    return {
      mostrado: false,
      solicitudId: null,
      form: {
        observaciones: null,
        fecha_desembolso: null,
        detalle_solicitud_desembolso: [],
      },
      enviado: false,
      errores: [],
      snackbar: false,
      item: {
        numero: null,
        user: null,
        created_at: null,
        estado: null,
        detalle_solicitud: [],
      },
      confirmacion: {
        titulo: 'Desembolsar',
        mensaje: '¿Está seguro de desembolsar los recursos?',
        realizandoAccion: false,
      },
      tipoSolicitudRecursos: TIPOS_SOLICITUD.RECURSOS,
      detallesSolicitudesSeleccionados: [],
    };
  },
  computed: {
    esTipoRecursos() {
      return this.tipo === TIPOS_SOLICITUD.RECURSOS;
    },
    detallesSolicitud() {
      return this.item.detalle_solicitud.filter((detalle) => detalle.estado === ESTADOS_DETALLE_SOLICITUD.APROBADO);
    },
  },
  watch: {
    'form.observaciones': function () {
      this.errores.observaciones = [];
    },
    'form.fecha_desembolso': function () {
      this.errores.fecha_desembolso = [];
    },
    detallesSolicitud: {
      handler: function () {
        this.form.detalle_solicitud_desembolso = this.detallesSolicitud.map((detalle) => {
          return {
            id: detalle.id,
            tipo_desembolso: detalle.tipo_desembolso,
          };
        });
      },
      deep: true,
    },
    mostrado: function () {
      if (!this.mostrado) {
        this.$emit('cambiarTipoDesembolsos', null);
      }
    },
  },
  methods: {
    abrirModal(item) {
      this.solicitudId = item.id;
      this.item = item;
      this.form.fecha_desembolso = null;
      this.form.observaciones = null;
      this.mostrado = true;
      this.errores = [];
    },
    cerrarModal() {
      this.resetear();
      this.mostrado = false;
    },
    validar() {
      if (!this.enviado) {
        this.enviado = true;
        this.desembolsar();
      }
    },
    actualizar() {
      this.cerrarModal();
      this.enviado = false;
      this.$emit('actualizar');
    },
    resetear() {
      this.solicitudId = null;
      this.item = {
        numero: null,
        user: null,
        created_at: null,
        estado: null,
        detalle_solicitud: [],
      };
      this.form.fecha_desembolso = null;
      this.form.observaciones = null;
      this.errores = [];
    },
    async desembolsar() {
      if (this.detallesSolicitudesSeleccionados.length == 0) {
        this.$notify({
          group: 'notifications',
          title: 'ERROR',
          text: 'DEBE SELECCIONAR AL MENOS UN DETALLE DE LA SOLICITUD',
          type: 'error',
        });

        this.enviado = false;

        this.$refs.confirmacion.cerrar();

        return;
      }

      if (
        this.form.detalle_solicitud_desembolso.some(
          (detalle) => !detalle.tipo_desembolso && this.detallesSolicitudesSeleccionados.includes(detalle.id),
        )
      ) {
        this.$notify({
          group: 'notifications',
          title: 'ERROR',
          text: 'DEBE SELECCIONAR EL TIPO DE DESEMBOLSO PARA TODOS LOS DETALLES DE LA SOLICITUD SELECCIONADOS',
          type: 'error',
        });

        this.enviado = false;

        this.$refs.confirmacion.cerrar();

        return;
      }

      const datos = {
        observaciones: this.form.observaciones,
        fecha_desembolso: this.form.fecha_desembolso,
        detalle_solicitud_desembolso: this.form.detalle_solicitud_desembolso.filter((detalle) =>
          this.detallesSolicitudesSeleccionados.includes(detalle.id),
        ),
      };

      try {
        await SolicitudServices.desembolsar(this.solicitudId, datos);
        this.$notify({
          group: 'notifications',
          title: 'EL DESMBOLSO SE REALIZO CON EXITO',
          text: 'EXITO',
          type: 'success',
        });
        this.actualizar();
      } catch (error) {
        this.snackbar = true;
        this.mostrado = true;
        this.enviado = false;
        this.errores = error.response.data.errores;

        this.$notify({
          group: 'notifications',
          title: 'ERROR',
          text: 'EL DESEMBOLSO NO SE PUDO REALIZAR',
          type: 'error',
        });

        this.$refs.confirmacion.cerrar();
      }
    },
    aceptarDesembolso() {
      this.$refs.confirmacion.abrir();
    },
  },
};
</script>
  <style>
.v-dialog {
  align-items: flex-start;
}
</style>